import { SelectionSettlementStatus } from "../../../../types";
export const isDeadHeatRuleApplied = (bet) => {
    return bet.selections.some(selection => selection.settlementStatus === SelectionSettlementStatus.WonDeadHeat || selection.settlementStatus === SelectionSettlementStatus.PlacedDeadHeat);
};
//# sourceMappingURL=isDeadHeatRuleApplied.js.map